import React from 'react';

const RiskTitle = ({score}) => {

    let scoreClass, risk, description;
    if(score < 5) {
        scoreClass = 'score-color-low';
        risk = 'Low risk';
        description= 'Right now, your risk for having type 2 diabetes is low. However, your risk changes over time. Be sure to schedule regular check-ups with your doctor and take healthy steps toward preventing or delaying diabetes';
    }else {
        scoreClass = 'score-color-high';
        risk = 'High risk';
        description= 'Your risk for having type 2 diabetes is high. Only your doctor can tell for sure if you have diabetes or prediabetes. These conditions often do not cause any symptoms; so, don’t wait to make an appointment with your doctor';
    }
    return (
        <div className="text-center mt-4">
            <div className={`number-circle ${scoreClass}`}>{score}</div>
            <h5 className='risk-score-lable'>RISK SCORE</h5>
            <h4>You are at <span className={score < 5 ? 'green' : 'red'}>{risk}</span></h4>
            <p className="mb-0">{description}</p>
        </div>
    );
}

export default RiskTitle;